import React, { useContext, useState } from 'react';
import { TheAppContext } from 'provider/AppContext';
import Success from './Success';
import Submitting from './Submitting';
import Error from './Error';

import { Button, TextField, Typography, Box } from '@mui/material';
import { Email, GitHub, LinkedIn, Send } from '@mui/icons-material';
const initInputs = [
  {
    displayName: 'Your Name',
    id: 'name',
    content: '',
    required: true,
    type: 'text',
  },
  {
    displayName: 'Your Email',
    id: 'email',
    content: '',
    required: true,
    type: 'text',
  },
  {
    displayName: 'Message',
    id: 'message',
    content: '',
    required: true,
    type: 'textarea',
  },
];
const Contact = () => {
  const { setBoxShowing } = useContext(TheAppContext);
  const [form, setForm] = useState<any>({
    status: 'filling',
    inputs: initInputs,
    message: 'Contact Me',
    errors: [],
  });

  const handleChange = (e) => {
    const name = e.target.name;
    const inputs = [...form.inputs];
    let input = inputs.find((i) => i.id === name);
    input.content = e.target.value;
    setForm((prev) => ({ ...prev, inputs }));
  };

  const handleSubmit = async () => {
    setForm((prev) => ({
      ...prev,
      status: 'submitting',
      message: 'Hang On...',
    }));
    let formJson: Record<string, string> = {};
    form.inputs.forEach((i: any) => {
      if (i.content === '') {
        setForm((prev) => ({
          ...prev,
          status: 'filling',
          errors: ['Please fill out all fields!'],
        }));
        throw 'An error occured';
      }
      formJson[i.id] = i.content;
    });

    return await fetch(process.env.FORM_ENDPOINT ?? '', {
      headers: {
        'content-type': 'application/json',
      },
      mode: 'no-cors',
      method: 'POST',
      body: JSON.stringify({
        to: formJson.email,
        data: {
          formValues: [
            {
              label: 'Email',
              value: formJson.email,
            },
            {
              label: 'Name',
              value: formJson.name,
            },
            {
              label: 'Message',
              value: formJson.message,
            },
          ],
        },
      }),
    })
      // .then((res) => res.json())
      .then((result) => {
        setForm((prev) => ({
          ...prev,
          status: 'complete',
          message: 'Thanks!',
        }));
      })
      .catch((err) => {
        console.log({ err });
        setForm((prev) => ({
          ...prev,
          status: 'filling',
          message: 'Try Again...',
        }));
      });
  };

  const handleClose = () => {
    setBoxShowing({ visible: false, component: null });
  };
  return (
    <Box className={'bg--4'} sx={{ p: 4 }}>
      <Box
        sx={{
          maxWidth: '360px',
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          mx: 'auto',
        }}
      >
        <Typography variant="h3">{form.message}</Typography>
        {form.status === 'submitting' && <Submitting />}
        {form.status === 'complete' && <Success handleClose={handleClose} />}
        {form.status === 'filling' && (
          <>
            {form.errors.length > 0 ? <Error errors={form.errors} /> : ''}

            {form.inputs.map((i, index) => (
              <TextField
                variant="filled"
                key={`${i.id}--${index}`}
                label={i.displayName}
                name={i.id}
                onChange={handleChange}
                type={i.type === 'textarea' ? 'text' : i.type}
                multiline={i.type === 'textarea'}
                rows={i.type === 'textarea' ? 4 : 1}
              />
            ))}

            <Button
              onClick={handleSubmit}
              variant="contained"
              endIcon={<Send />}
            >
              {form.errors.length > 0 ? 'Try Again...' : 'Send'}
            </Button>
          </>
        )}
        <Box>
          <Typography variant="body1"> You can also reach me here: </Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <a
              href={'https://www.linkedin.com/in/albertksigman26/'}
              target="_blank"
              rel="prefetch"
            >
              <LinkedIn sx={{ fontSize: '2.5rem' }} />
            </a>
            <a
              href={'https://github.com/nightingalemedia'}
              target="_blank"
              rel="prefetch"
            >
              <GitHub sx={{ fontSize: '2.5rem' }} />
            </a>
            <a href="mailto:alsigman@gmail.com" target="_blank" rel="prefetch">
              <Email sx={{ fontSize: '2.5rem' }} />
            </a>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Contact;
